let Translations = {
    fr: {
        logout: 'déconnexion'
    },
    en: {
        logout: 'logout'
    },
    zh: {
        logout: '登出'
    }
};
export {Translations}